import React, { useEffect } from 'react'

import ConnectSvg from 'components/Common/SvgIcons/Connect'
import Button from 'components/Common/Button'
import { ConnectGoLogicPlatform } from 'components/FakePlaysComponent/style'
import { PLAY_STEP_TYPE } from 'components/Owner/Plays/PlaysAuthentication'
import { isEmpty } from 'lodash'

const PlaySuccessCard = ({
  data,
  userId,
  playData,
  moveNext,
  playValue,
  isConnected,
  uploadedFile,
  isPlayCompleted,
  savePlayDataAction,
}) => {
  useEffect(() => {
    if (!isEmpty(uploadedFile) && !isConnected && !isPlayCompleted) {
      let assessmentResponseObj = {
        userId: userId,
        type: playData?.recommendedBy?.type,
        assessmentResponse: {
          [playData?.meta?.questionType]: true,
          playResponse: JSON.stringify({
            [`${playData.id}`]: { value: { [playData?.meta?.questionType]: [uploadedFile] } },
          }),
          id: playData?.recommendedBy?.id,
        },
      }
      savePlayDataAction({
        question: playData?.meta?.questionType,
        assessmentResponseObj: assessmentResponseObj,
      })
    }
    // eslint-disable-next-line
  }, [uploadedFile])
  return (
    ((data.stepType === PLAY_STEP_TYPE.INPUT && isConnected) ||
      (data.stepType === PLAY_STEP_TYPE.UPLOAD && !isEmpty(playValue))) && (
      // (data.stepType === PLAY_STEP_TYPE.CONNECTION && isConnected)) && (
      <>
        <div id="SuccessCard">
          <ConnectGoLogicPlatform>
            <div className="w-full max-w-[500px] connectGologinWrap">
              <div className="successConnected w-full max-w-[500px]">
                <div className="text-lg text-[#A1A1AA] mb-4">Success!</div>
                <div className="text-xl text-primary-text">{data?.meta?.successMessage}</div>
                <div className="successfullCircle">
                  <ConnectSvg />
                </div>
              </div>
            </div>
          </ConnectGoLogicPlatform>
          {!playData?.playTabs && (
            <div className="mt-4">
              {/* check-button -- clean up custom text-sm */}
              <Button
                variant="primary"
                type="button"
                label="Learn how to use this tool in your business!"
                onClick={moveNext}
                className="text-sm w-full"
                disabled={isPlayCompleted}
              />
            </div>
          )}
        </div>
      </>
    )
  )
}

PlaySuccessCard.defaultProps = {
  data: '',
  userId: '',
  playData: {},
  playValue: '',
  uploadedImage: '',
  isConnected: false,
  isPlayCompleted: false,
  savePlayDataAction: () => {},
}

export default PlaySuccessCard
